const DEFAULT_TOPIC = {
  name: 'All',
  slug: 'all-topics',
}

const SEE_ALL_TOPIC = {
  name: 'See all topics ',
  variant: 'purple',
  enabled: true,
  slug: 'see-all-topics',
}

export { DEFAULT_TOPIC, SEE_ALL_TOPIC }
